<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-2">
          <base-button
            style="font-size: 18px"
            @click="getBack()"
            class="btn-link btn-primary"
          >
            &lt; Back
          </base-button>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-md-12">
          <simple-wizard
            ref="tabs"
            :indextghrunning="huhuhaha"
            :totalstep="hoi"
          >
            <template slot="header">
              <h2 class="card-title"></h2>
              <h3 class="description"></h3>
            </template>

            <!-- v-if="flag" -->
            <wizard-tab
              :activeTabIndex="activeTabIndex"
              :before-change="() => validateStep('step1')"
            >
              <template slot="label">
                1

                <p
                  style="color: #A5A5A5; width: 200px"
                >
                  Job Schedule
                </p>
               
              </template>
              <first-step
                v-if="firstflag"
                :curr="curr"
                @my-event="myFunction"
                ref="step1"
                @on-validated="onStepValidated"
              ></first-step>
            </wizard-tab>

            <wizard-tab
              :activeTabIndex="activeTabIndex"
              :before-change="() => validateStep('step2')"
            >
              <template slot="label">
                2
                <p style="color: #A5A5A5; width: 200px">PTW & eCAF</p>
              </template>
              <second-step
                v-if="secondflag"
                :key="componentKey"
                @my-event="myFunction"
                ref="step2"
                @on-validated="onStepValidated"
              ></second-step>
            </wizard-tab>

            <wizard-tab
              :before-change="() => validateStep('step3')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                3
                <p style="color: #A5A5A5; width: 200px">Signed DO</p>
              </template>
              <third-step
              v-if="thirdflag"
                @my-event="myFunction"
                ref="step3"
                @on-validated="onStepValidated"
              ></third-step>
            </wizard-tab>
            <!-- v-if="flag" -->
            <wizard-tab
              :before-change="() => validateStep('step4')"
              :activeTabIndex="activeTabIndex"
              
            >
              <template slot="label">
                4
                <p
                  style="color: #A5A5A5; width: 200px"
                 
                >
                  Terminated PTW
                </p>
              </template>
              <fourth-step
              v-if="fourthflag"
                @my-event="myFunction"
                ref="step4"
                @on-validated="onStepValidated"
              ></fourth-step>
            </wizard-tab>
          </simple-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "../../Admin/Outgoing/JobPage/Calendar.vue";
import SecondStep from "../../Admin/Outgoing/JobPage/PTWnEkaf.vue";
import ThirdStep from "../../Admin/Outgoing/JobPage/SignedDO.vue";
import FourthStep from "../../Admin/Outgoing/JobPage/TerminatedPTW.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  data() {
    return {
      componentKey: 0,
      wizardModel: {},
      activeTabIndex: 0,
      jobstatus: "",
      landvesselflag: "VESSEL",
      huhuhaha: 0,
      hoi: 0,
      flag: true,
      curr: 0,
      firstflag: true,
      secondflag: false,
      thirdflag: false,
      fourthflag: false,
      fifthflag: false,

    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,

    SimpleWizard,
    WizardTab,
  },
  created() {

    setTimeout(() => {
     
      this.curr = 1

    }, 100)
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
      console.log("rerender: ", this.componentKey);
      this.getDetail(this.$route.params.jobnum.split("_")[0]);
    },
   
    myFunction(e) {
      // this.firstflag = false
      this.secondflag = false 
      this.thirdflag = false 
      this.fourthflag = false

      this.flag = false;
      let index = parseInt(e.step);
      // this.huhuhaha = index;
      this.hoi = 4
      // console.log("e", e);
      // console.log(e.direction);
      

      if (e.direction == "depan") {
        // bila step 1, dia kan move ke step 2
        if (e.step == "0") {
          // this.firstflag = true
          // active = content of child
          // checked = bullet tab
          // display quotation page

          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
           
            this.huhuhaha = 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }
        if (e.step == "1") {
          // active = content of child
          // checked = bullet tab
          // display quotation page
          this.secondflag = true
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            
            this.huhuhaha = 2;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }

        if (e.step == "2") {
          this.thirdflag = true
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.huhuhaha = 3;
            // this.huhuhaha = parseInt(e.step);
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
        }

        if (e.step == "3") {
          this.fourthflag = true
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = true;
            this.$refs.tabs.tabs[this.hoi - 1].checked = true;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.huhuhaha = 4;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }

      }

      if (e.direction == "blkg") {
        if (e.step == "1") {
          this.getBack();
        }

        if (e.step == "2") {
          this.firstflag = true
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
       
          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "3") {
          this.secondflag = true
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "4") {
          this.thirdflag = true
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;  

            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

     
      }

    
    },
    getBack() {
      this.$router.push("/Outgoing");
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    validate(tab) {
      let tabToValidate = tab || this.activeTab;

      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then((res) => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    },
  },
  watch: {
    // curr(){
    //     console.log(this.curr)

    // },
    // testtest(){
    //   this.ee
    // }
  }
};
</script>
